var map = {
	"./logo__1.svg": 672,
	"./logo__11.svg": 673,
	"./logo__12.svg": 674,
	"./logo__13.svg": 675,
	"./logo__14.svg": 676,
	"./logo__15.svg": 677,
	"./logo__2.svg": 678,
	"./logo__24.svg": 679,
	"./logo__3.svg": 680,
	"./logo__4.svg": 681,
	"./logo__44.svg": 682,
	"./logo__5.svg": 683,
	"./logo__6.svg": 684,
	"./logo__62.svg": 685,
	"./logo__7.svg": 686,
	"./logo__8.svg": 687,
	"./logo__9.svg": 688
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 929;